import { render, staticRenderFns } from "./VehicleDismantleBULK.vue?vue&type=template&id=5b29e338&"
import script from "./VehicleDismantleBULK.vue?vue&type=script&lang=js&"
export * from "./VehicleDismantleBULK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports